/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UserInfoDto, UserProfileDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class MyAccountService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags MyAccountService
   * @name GetMyProfile
   * @summary Get My Profile
   * @request GET:/v1/me/profile
   * @secure
   */
  getMyProfile = (params: RequestParams = {}) =>
    this.http.request<UserProfileDto, any>({
      path: `/v1/me/profile`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MyAccountService
   * @name SaveMyProfile
   * @summary Save or Update My Profile
   * @request POST:/v1/me/profile
   * @secure
   */
  saveMyProfile = (data: UserProfileDto, params: RequestParams = {}) =>
    this.http.request<UserProfileDto, any>({
      path: `/v1/me/profile`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags MyAccountService
   * @name GetMyAccount
   * @summary Get My Account
   * @request GET:/v1/me
   * @secure
   */
  getMyAccount = (params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/me`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
